// Tab functionality is handled in our-story-product.liquid

function initOurStoryVisualVideo() {
	const playButton = document.querySelector('.our-story__visual--play');
	const video = document.querySelector('.our-story__visual--video video');
	const pauseButton = document.querySelector('.our-story__visual--pause');
	const thumbnail = document.querySelectorAll('.our-story__visual--thumbnail');

	if (!video || !playButton || !pauseButton) return;

	playButton.addEventListener('click', () => {
		video.play();
		playButton.classList.add('hidden');
		pauseButton.classList.remove('hidden');
		thumbnail.forEach(item => {
			item.classList.add('hide');
		});
	});

	pauseButton.addEventListener('click', () => {
		video.pause();
		pauseButton.classList.add('hidden');
		playButton.classList.remove('hidden');
	});
}

initOurStoryVisualVideo();

// Our story contents video 
function wireOurStoryContentsVideo(video) {
	if (video.dataset.boundWire === 'true') return;
	const wrapper = video.closest('.our-story__contents--video');
	if (!wrapper) return;

	video.addEventListener('pointerup', e => {
		if (video.controls) return;
		if (e.target !== video) return;
		if (video.paused) video.play();
		else video.pause();
	});

	video.addEventListener('play', () => {
		video.controls = true;
		wrapper.classList.add('play');
		wrapper.classList.add('has-started');
	});

	video.addEventListener('pause', () => {
		wrapper.classList.remove('play');
		setTimeout(() => {
			if (video.paused) video.controls = false;
		}, 200);
	});

	video.addEventListener('ended', () => {
		wrapper.classList.remove('play');
		setTimeout(() => {
			video.controls = false;
		}, 0);
	});

	video.dataset.boundWire = 'true';
}

function bindOurStoryContentsVideos(root = document) {
	root.querySelectorAll('.our-story-contents__video-player').forEach(wireOurStoryContentsVideo);
}

document.addEventListener('DOMContentLoaded', () => {
	bindOurStoryContentsVideos(document);
});

document.addEventListener('shopify:section:load', e => {
	bindOurStoryContentsVideos(e.target);
});

const scrollUI = document.querySelector('.our-story__visual--scroll');

function visibleScrollUI() {
	setTimeout(() => {
		scrollUI.classList.add('visible');
	}, 1000);
}

function hiddenScrollUI() {
	window.addEventListener('scroll', event => {
		const scrollTop = window.scrollY;
		if (scrollTop > 150) {
			scrollUI.classList.remove('visible');
		} else {
			scrollUI.classList.add('visible');
		}
	});
}

visibleScrollUI();
hiddenScrollUI();
